/** @ignore */
import qtfm from './qtfm.cn';
import qingting from './qingting.fm';
import bjqtthirdbase from './bjqtthirdbase.com';
import bjqtforthbase from './bjqtforthbase.com';
import bjqtfifthbase from './bjqtfifthbase.com';
import { getEasyRootDomain } from '../utils';

const rootDomain = getEasyRootDomain();

const site = {
  'qtfm.cn': qtfm,
  'qingting.fm': qingting,
  'bjqtthirdbase.com': bjqtthirdbase,
  'bjqtforthbase.com': bjqtforthbase,
  'bjqtfifthbase.com': bjqtfifthbase,
};

console.log('current domain is ', rootDomain);

export default site[rootDomain];
